import React, { useEffect, useState } from "react";
import moment from "moment";
import { Card, CardHeader, CardTitle, CardBody } from "reactstrap";
import { MDBDataTable } from "mdbreact";
import "./index.styles.scss";
import { convertDateFormat } from "../../../utils/helperFunctions";
import { Row, Col } from "reactstrap";
import { translate } from "react-i18next";

const RecentDoorOpening = ({
  recentDoors,
  onMinimizeToggle,
  isExpanded,
  getRecentDoorsList,
  t,
}) => {
  const [isMinimized, setIsMinimized] = useState(isExpanded);
  const [page, setPage] = useState(null);
  const [isLightMode, setIsLightMode] = useState(
    document.documentElement.getAttribute("data-theme") === "light"
  );

  const ra_columns = [
    {
      label: t("dashboard.device"),
      field: "deviceName",
      sort: "asc",
      width: 150,
    },
    {
      label: t("dashboard.location"),
      field: "location",
      sort: "asc",
      width: 126,
    },
    {
      label: t("dashboard.user"),
      field: "user",
      sort: "asc",
      width: 150,
    },
    {
      label: t("dashboard.timeOpened"),
      field: "timeOpened",
      sort: "asc",
      width: 100,
    },
    {
      label: t("dashboard.timeClosed"),
      field: "timeClosed",
      sort: "asc",
      width: 98,
    },

    {
      label: t("dashboard.date"),
      field: "createdAt",
      sort: "asc",
      width: 150,
    },
  ];
  // const isLightMode = localStorage.getItem("data-theme") === "light";

  const ra_rows = recentDoors
    ? recentDoors.data &&
      recentDoors.data.map((alarm) => {
        let alarmRow = { ...alarm };
        alarmRow.createdAt = convertDateFormat(alarmRow.createdAt, "shortDate");

        alarmRow.deviceName = alarm.deviceName;
        alarmRow.user = alarmRow.user;
        alarmRow.timeOpened =
          moment(alarmRow.timeOpened).format("hh:mm:ss") === "Invalid date"
            ? "N/A"
            : moment(alarmRow.timeOpened).format("hh:mm:ss");
        alarmRow.timeClosed =
          moment(alarmRow.timeClosed).format("hh:mm:ss") === "Invalid date"
            ? "N/A"
            : moment(alarmRow.timeClosed).format("hh:mm:ss");
        // return alarmRow;
        alarmRow.location = alarmRow.location ? alarmRow.location : "N/A";
        // console.log(alarmRow);
        return alarmRow;
      })
    : [];

  const recentDoorList = {
    columns: ra_columns,
    rows: ra_rows,
  };

  const toggleMinimize = () => {
    const newMinimizedState = !isMinimized;
    setIsMinimized(newMinimizedState);
    onMinimizeToggle(newMinimizedState);
  };

  const { data, ...paging } = recentDoors;

  useEffect(() => {
    if (page >= 1) {
      getRecentDoorsList(page);
    }
  }, [page]);

  // Handle theme changes
  useEffect(() => {
    const handleThemeChange = () => {
      const currentTheme = document.documentElement.getAttribute("data-theme");
      setIsLightMode(currentTheme === "light");
    };

    // Listen for the 'storage' event triggered by ThemeSwitch
    window.addEventListener("storage", handleThemeChange);

    // Clean up listener on unmount
    return () => {
      window.removeEventListener("storage", handleThemeChange);
    };
  }, []);

  return (
    <Card
      className={`mb-0 ${isMinimized ? "minimized" : ""}`}
      style={{
        width: "100%",
        padding: "1px",
        // marginBottom: "-2px",
        border: "1px solid var(--dropdown-border-bg)",
        borderRadius: "0.25rem",
        height: "100%",
      }}
    >
      <CardHeader
        className="recent-alarms__header"
        style={{ position: "relative" }}
      >
        <CardTitle>{t("dashboard.recentDoorOpenings")}</CardTitle>
        {/* <button onClick={toggleMinimize}>
          {isMinimized ? (
            <>
              <i className="fa fa-chevron-down" aria-hidden="true"></i>{" "}
              {t("dashboard.maximize")}
            </>
          ) : (
            <>
              <i className="fa fa-chevron-up" aria-hidden="true"></i>{" "}
              {t("dashboard.minimize")}
            </>
          )}
        </button> */}
      </CardHeader>
      <div
        style={{
          height: "1px",
          width: "100%",
          background: "#ccc",
        }}
      />
      {
        <CardBody
          // className={`recent-alarms__body ${isMinimized ? "minimized" : ""}`}
          style={{
            paddingLeft: "10px",
            marginLeft: "10px",
            position: "relative",
            overflowY: "auto",
            overflowX: "hidden",
            height: "100%",
          }}
        >
          <>
            <MDBDataTable
              className="recentAlarmTable border-0 "
              data={recentDoorList}
              paging={false}
              searching={false}
              scrollY
              scrollX
              maxHeight="820px"
              bordered
              noRecordsFoundLabel={t("dashboard.noMatchingRecordsFound")}
              style={{ overflow: "auto" }}
            />
            <Row
              // className="mt-3 mb-3"
              className="recent-alarms__header"
              style={{
                position: "sticky",
                width: "100%",
                bottom: 0,
                paddingLeft: 40,
                paddingRight: 40,
                padding: 6,
                marginLeft: -1.5,
                marginRight: 16,
                backgroundColor: isLightMode ? "white" : "#111218",
                // marginTop: "20px",
                overflow: "hidden",
                // zIndex: 999,
              }}
            >
              <Col
                lg={6}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <label style={{ marginBottom: 0 }}>
                  {t("dashboard.showing")} {(paging.page || 1) * 10 - 9}{" "}
                  {t("dashboard.to")} {(paging.page || 1) * 10}{" "}
                  {t("dashboard.ofAllResults")}
                </label>
              </Col>
              <Col
                lg={6}
                className="text-right d-flex"
                style={{
                  width: "100%",
                  alignItems: "center",
                  cursor: "pointer",
                  justifyContent: "flex-end",
                }}
              >
                <i
                  className="fas fa-angle-double-left mr-4 fa-1x"
                  onClick={() => {
                    if (page > 1) {
                      setPage((page || 1) - 1);
                    }
                  }}
                ></i>
                <i
                  className="fas fa-angle-double-right fa-1x"
                  onClick={() => {
                    if (page !== paging.total) {
                      setPage((page || 1) + 1);
                    }
                  }}
                ></i>
              </Col>
            </Row>
          </>
        </CardBody>
      }
    </Card>
  );
};

export default translate("translations")(RecentDoorOpening);
